// extracted by mini-css-extract-plugin
module.exports = {"successRate":"SuccessRateInfo_successRate__ttw8_","row":"SuccessRateInfo_row__UgtTf","title":"SuccessRateInfo_title__TaJRR","rateDetails":"SuccessRateInfo_rateDetails__kq7K_"};